module.exports = __webpack_public_path__ + "media/images/icons/Icon-star-93811e0c7e4c35184510392ae3e7480a.svg";